var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1157.3 578.38-582.9-419.93c-5.332-3.8359-11.895-5.5664-18.43-4.8594-6.5312 0.70703-12.57 3.8008-16.961 8.6914-4.3906 4.8867-6.8203 11.223-6.8242 17.793v222.06l-474 0.003906c-7.0664 0.003906-13.84 2.8164-18.836 7.8125-5 4.9961-7.8086 11.773-7.8164 18.84v342.43c0 7.0664 2.8086 13.844 7.8086 18.84s11.777 7.8008 18.844 7.7969h474v222.07c0.003906 6.5703 2.4336 12.906 6.8242 17.793 4.3906 4.8906 10.43 7.9844 16.961 8.6914 6.5352 0.70703 13.098-1.0234 18.43-4.8594l582.9-419.93c6.9531-5.0078 11.074-13.055 11.074-21.625s-4.1211-16.617-11.074-21.625z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c3d129addce4e57b284b5e94a99871e5.svg";
export { ForwardRef as ReactComponent };